import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getToken } from "@/api";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Prospects from "@/pages/Prospects";
import Opportunities from "@/pages/Opportunities";
import Conversations from "@/pages/Conversations";
import Outcomes from "@/pages/Outcomes";
import MarketplaceQueue from "@/pages/MarketplaceQueue";
import Targets from "@/pages/Targets";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/targets" element={<Protected><Targets /></Protected>} />
          <Route path="/prospects" element={<Protected><Prospects /></Protected>} />
          <Route path="/opportunities" element={<Protected><Opportunities /></Protected>} />
          <Route path="/marketplace" element={<Protected><MarketplaceQueue /></Protected>} />
          <Route path="/conversations" element={<Protected><Conversations /></Protected>} />
          <Route path="/outcomes" element={<Protected><Outcomes /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
